export const POST_DRAWER_HELPER = 'All Posts are posted on the home feed';
